import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { RouteErrorBoundary } from "./components/RouteErrorBoundary";
import "./styles.css";
import "./theme.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouteErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RouteErrorBoundary>
  </StrictMode>,
);
